var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTechnicalSkillsGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.85059L3.35355 5.20414C3.54882 5.00888 3.54882 4.69229 3.35355 4.49703L3 4.85059ZM3.5 1.35059H15.5V0.350586H3.5V1.35059ZM7.5 5.35059H15.5V4.35059H7.5V5.35059ZM3.5 9.35059H15.5V8.35059H3.5V9.35059ZM1.35355 7.20414L3.35355 5.20414L2.64645 4.49703L0.646447 6.49703L1.35355 7.20414ZM3.35355 4.49703L1.35355 2.49703L0.646447 3.20414L2.64645 5.20414L3.35355 4.49703Z",
    fill: "#005956"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnicalSkillsGreen);
export default __webpack_public_path__ + "static/media/technical-skills-green.b60b361946335cff54bdbd4e0f54117b.svg";
export { ForwardRef as ReactComponent };